module.exports = __webpack_public_path__ + "img/sieckFinesseEnergy1.51c7cd77.png";